import { combineReducers } from "@reduxjs/toolkit";
import authSlice from "../../features/auth/presentation/store/auth/AuthSlice";
import onboardingSlice from "../../features/profile/presentation/store/OnboardingSlice";
import settingsSlice from "../../features/settings/presentation/store/SettingSlice";
import partnerSlice from "../../features/settings/presentation/store/PartnerSlice";
import matchSlice from "../../features/match/presentation/store/MatchSlice";
import chatSlice from "../../features/chat/presentation/store/ChatSlice";
import subscriptionSlice from "../../features/subscriptions/presentation/store/SubscriptionsSlice";
import adminSlice from "../../features/admin/presentation/store/AdminSlice";
import notificationSlice from "../../features/notification/presentation/store/NotificationSlice";

const combineRootReducer = combineReducers({
	auth: authSlice,
	onboarding: onboardingSlice,
	settings: settingsSlice,
	match: matchSlice,
	chat: chatSlice,
	partner: partnerSlice,
	subscriptions: subscriptionSlice,
	admin: adminSlice,
	notification: notificationSlice,
});
const rootReducer = (state: any, action: any) => {
	if(action.type === "DESTROY_SESSION"){
	  state = undefined;
	}
	return combineRootReducer(state, action);
  }
export default rootReducer;
